import React from 'react';
import * as S from './styles';
import { CaretDoubleUp, CaretUp, HexagonMinus } from 'components/Icons';

interface IQualifications {
  amount: string | undefined;
  status: 'baixo' | 'medio' | 'alto';
}

const Qualifications = ({ amount, status }: IQualifications) => {
  const icons = {
    baixo: <HexagonMinus />,
    medio: <CaretUp />,
    alto: <CaretDoubleUp />,
  };

  const icon = icons[status] || null;
  const text = {
    baixo: 'frios',
    medio: 'mornos',
    alto: 'quentes',
  };

  return (
    <S.Content>
      {icon}
      <div>
        <S.TextAside fontSize="16" fontWeight="700">
          {amount}
        </S.TextAside>
        <S.TextAside fontSize="12" color="#808080">
          Leads {text[status] || 'não informados'}
        </S.TextAside>
      </div>
    </S.Content>
  );
};

export default Qualifications;
